import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_FAMILY_CLAN_LEVEL_DIALOG } from "../../store/familyClanLevel/types";

//action
import {
  createNewFamilyClanLevel,
  editFamilyClanLevel,
} from "../../store/familyClanLevel/action";
import { permissionError } from "../../util/Alert";

const FamilyClanLevelDialog = (props) => {
  const dispatch = useDispatch();

  const { dialog: open, dialogData } = useSelector(
    (state) => state.familyClanLevel,
  );

  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [mongoId, setMongoId] = useState("");
  const [name, setName] = useState("");
  const [exp, setExp] = useState("");
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);
  const [maxMembers, setMaxMembers] = useState("");
  const [maxCoCaptains, setMaxCoCaptains] = useState("");
  const [maxAdmins, setMaxAdmins] = useState("");

  const [errors, setError] = useState({
    name: "",
    exp: "",
    image: "",
    maxMembers: "",
    maxCoCaptains: "",
    maxAdmins: "",
  });

  useEffect(() => {
    if (dialogData) {
      setMongoId(dialogData._id);
      setName(dialogData.name);
      setExp(dialogData.exp);
      setImagePath(dialogData.image);
      setMaxMembers(dialogData.benefits?.members?.maxMembers || "");
      setMaxCoCaptains(dialogData.benefits?.members?.maxCoCaptains || "");
      setMaxAdmins(dialogData.benefits?.members?.maxAdmins || "");
    }
  }, [dialogData]);

  useEffect(
    () => () => {
      setError({
        name: "",
        exp: "",
        image: "",
        maxMembers: "",
        maxCoCaptains: "",
        maxAdmins: "",
      });
      setMongoId("");
      setName("");
      setExp("");
      setImageData(null);
      setImagePath(null);
      setMaxMembers("");
      setMaxCoCaptains("");
      setMaxAdmins("");
    },
    [open],
  );

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  const HandleInputImage = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const closePopup = () => {
    dispatch({ type: CLOSE_FAMILY_CLAN_LEVEL_DIALOG });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !exp || !maxMembers || !maxCoCaptains || !maxAdmins) {
      const errors = {};
      if (!name) errors.name = "Family Clan Level Name is Required!";
      if (!exp) errors.exp = "Experience (EXP) is Required!";
      if (!maxMembers) errors.maxMembers = "Max Members is Required!";
      if (!maxCoCaptains) errors.maxCoCaptains = "Max Co-Captains is Required!";
      if (!maxAdmins) errors.maxAdmins = "Max Admins is Required!";
      if (!imageData && !imagePath)
        return setError({ ...errors, image: "Please select an Image!" });

      return setError({ ...errors });
    } else {
      const expValid = isNumeric(exp);
      const maxMembersValid = isNumeric(maxMembers);
      const maxCoCaptainsValid = isNumeric(maxCoCaptains);
      const maxAdminsValid = isNumeric(maxAdmins);

      if (!expValid) {
        return setError({ ...errors, exp: "Invalid EXP!!" });
      }
      if (!maxMembersValid) {
        return setError({ ...errors, maxMembers: "Invalid Max Members!!" });
      }
      if (!maxCoCaptainsValid) {
        return setError({
          ...errors,
          maxCoCaptains: "Invalid Max Co-Captains!!",
        });
      }
      if (!maxAdminsValid) {
        return setError({ ...errors, maxAdmins: "Invalid Max Admins!!" });
      }

      const formData = new FormData();

      formData.append("name", name);
      formData.append("exp", exp);
      formData.append("benefits[members][maxMembers]", maxMembers);
      formData.append("benefits[members][maxCoCaptains]", maxCoCaptains);
      formData.append("benefits[members][maxAdmins]", maxAdmins);
      if (imageData) {
        formData.append("image", imageData);
      }

      if (!hasPermission) return permissionError();

      if (mongoId) {
        props.editFamilyClanLevel(mongoId, formData);
      } else {
        if (!imageData || !imagePath)
          return setError({ ...errors, image: "Please select an Image!" });
        props.createNewFamilyClanLevel(formData);
      }
    }
  };

  const isNumeric = (value) => {
    const val = value === "" ? 0 : value;
    const validNumber = /^\d+$/.test(val);
    return validNumber;
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4">
            {" "}
            Family Clan Level{" "}
          </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="form-group">
                  <label className="mb-2 text-gray">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    required=""
                    placeholder="Family Clan Level Name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          name: "Family Clan Level Name is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          name: "",
                        });
                      }
                    }}
                  />
                  {errors.name && (
                    <div className="ml-2 mt-1">
                      {errors.name && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.name}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Experience (EXP)</label>
                  <input
                    type="number"
                    className="form-control"
                    required=""
                    placeholder="1000"
                    value={exp}
                    onChange={(e) => {
                      setExp(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          exp: "Experience (EXP) is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          exp: "",
                        });
                      }
                    }}
                  />
                  {errors.exp && (
                    <div className="ml-2 mt-1">
                      {errors.exp && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.exp}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Max Members</label>
                  <input
                    type="number"
                    className="form-control"
                    required=""
                    placeholder="50"
                    value={maxMembers}
                    onChange={(e) => {
                      setMaxMembers(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          maxMembers: "Max Members is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          maxMembers: "",
                        });
                      }
                    }}
                  />
                  {errors.maxMembers && (
                    <div className="ml-2 mt-1">
                      {errors.maxMembers && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.maxMembers}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Max Co-Captains</label>
                  <input
                    type="number"
                    className="form-control"
                    required=""
                    placeholder="5"
                    value={maxCoCaptains}
                    onChange={(e) => {
                      setMaxCoCaptains(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          maxCoCaptains: "Max Co-Captains is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          maxCoCaptains: "",
                        });
                      }
                    }}
                  />
                  {errors.maxCoCaptains && (
                    <div className="ml-2 mt-1">
                      {errors.maxCoCaptains && (
                        <div className="pl-1 text__left">
                          <span className="text-red">
                            {errors.maxCoCaptains}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Max Admins</label>
                  <input
                    type="number"
                    className="form-control"
                    required=""
                    placeholder="10"
                    value={maxAdmins}
                    onChange={(e) => {
                      setMaxAdmins(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          maxAdmins: "Max Admins is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          maxAdmins: "",
                        });
                      }
                    }}
                  />
                  {errors.maxAdmins && (
                    <div className="ml-2 mt-1">
                      {errors.maxAdmins && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.maxAdmins}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Image</label>
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    accept="image/*"
                    required=""
                    onChange={HandleInputImage}
                  />
                  {errors.image && (
                    <div className="ml-2 mt-1">
                      {errors.image && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.image}</span>
                        </div>
                      )}
                    </div>
                  )}
                  {imagePath && (
                    <>
                      <img
                        height="70px"
                        width="70px"
                        alt="app"
                        src={imagePath}
                        style={{
                          boxShadow: "0 5px 15px 0 rgb(105 103 103 / 10%)",
                          border: "2px solid #fff",
                          borderRadius: 10,
                          marginTop: 10,
                          float: "left",
                        }}
                      />
                    </>
                  )}
                </div>

                <div className={imagePath ? "mt-5 pt-5" : "mt-5"}>
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { createNewFamilyClanLevel, editFamilyClanLevel })(
  FamilyClanLevelDialog,
);
